/* El vídeo de la obra: la pieza «Durante» del antes y después (`DG-20261013-003`,
   sección `aru-building`).

   - Arranca solo, sin sonido, mientras al menos la mitad está en pantalla, y se
     para al salir. `preload="none"` hace que el fichero no se descargue antes.
   - Una pantalla antes de que aparezca empieza a descargarse, para que arranque
     sin esperar al llegar. Nunca al abrir la página.
   - Con «reducir movimiento» no arranca solo: se queda el póster y el botón lo
     pone en marcha. Tampoco se adelanta la descarga.
   - El botón manda: parado a mano, se queda parado hasta que se vuelva a pulsar.
   - El nombre y el dibujo del botón siguen a los avisos `play`/`pause` del
     propio vídeo, así que nunca mienten. Los textos vienen de `locales/` en
     `data-texto-reproducir` y `data-texto-pausar`.
   Sin JavaScript el botón no sale y el póster es una foto más. */
(function () {
  'use strict';
  var video = document.querySelector('[data-obra-video]');
  var boton = document.querySelector('[data-obra-video-boton]');
  if (!video || !boton || !video.play) return;

  var textoReproducir = boton.getAttribute('data-texto-reproducir') || 'Reproducir el vídeo';
  var textoPausar = boton.getAttribute('data-texto-pausar') || 'Pausar el vídeo';
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');
  var aLaVista = false;
  var quiere = !sinMovimiento.matches;   /* ¿tiene que ir en marcha cuando esté en pantalla? */

  video.muted = true;

  function arrancar() {
    var promesa = video.play();
    /* Si el navegador no deja reproducir solo, o no hay red: se quedan el póster y el botón. */
    if (promesa && promesa.catch) promesa.catch(function () {});
  }
  function aplicar() {
    if (quiere && aLaVista) { if (video.paused) arrancar(); }
    else if (!video.paused) video.pause();
  }
  function pintar() {
    boton.setAttribute('data-estado', video.paused ? 'parado' : 'en-marcha');
    boton.setAttribute('aria-label', video.paused ? textoReproducir : textoPausar);
  }
  video.addEventListener('play', pintar);
  video.addEventListener('pause', pintar);

  boton.addEventListener('click', function () {
    quiere = video.paused;
    if (quiere) arrancar(); else video.pause();
  });

  function alCambiarPreferencia() { quiere = !sinMovimiento.matches; aplicar(); }
  if (sinMovimiento.addEventListener) sinMovimiento.addEventListener('change', alCambiarPreferencia);
  else if (sinMovimiento.addListener) sinMovimiento.addListener(alCambiarPreferencia);

  /* Los navegadores paran un vídeo sin sonido con la pestaña escondida, y no todos lo reanudan. */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) aplicar(); });

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entradas) {
      var ultima = entradas[entradas.length - 1];
      aLaVista = ultima.isIntersecting && ultima.intersectionRatio >= 0.5;
      /* Con «reducir movimiento», un vídeo puesto a mano no vuelve solo después de salir. */
      if (!aLaVista && sinMovimiento.matches) quiere = false;
      aplicar();
    }, { threshold: [0, 0.5] }).observe(video);

    var cerca = new IntersectionObserver(function (entradas) {
      if (!entradas[entradas.length - 1].isIntersecting) return;
      cerca.disconnect();
      if (sinMovimiento.matches || video.readyState !== 0 || !video.paused) return;
      /* Con cambiar `preload` basta para que empiece la descarga; un `load()` detrás la pide dos veces. */
      video.preload = 'auto';
    }, { rootMargin: '100% 0px' });
    cerca.observe(video);
  }

  boton.hidden = false;
  pintar();
})();
